import { Interpreter, assign, createMachine } from 'xstate-v4'
import { PrivacyType } from '../types'

type FavouritesMachineContext = {
  favourites: any[]
  wishlists: any | null
  currentList: any | null
  newWishlistName: string
  newWishlistPrivacy: PrivacyType
  errors: Record<string, string>
  guestRetries: number
}

type FavouritesMachineEvents = {
  type: 'CREATE_NEW_WISHLIST'
  callback?: () => void
}

export function getFavouritesMachine(
  favStore: ReturnType<typeof useFavouritesStore>,
) {
  return createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QDMCGA3A9gVwE4EsAXOAWVQGMALfAOzAGIBlACQHkB1AfQBEBRAMQCCAVQAyAFU5CAaq2EAlAJLjejTqMWNxAbQAMAXUSgADplhF8mGkZAAPRAFoAzAHYAdADYArABYvATn8vACYvAEYPF2CPABoQAE9ECKcnN2iw3R8fD10nUJcXAF9CuLQsPCJSCmo6JjYuDS09QyQQU3NCS2tW+wQHMOCfNwAOYbCs4eD-YaiwlzjEhDDXdycw4f9QlZyvD2LSjBwCYlgyKloGFg5OEkFFADlmm3aLKxtehyzPXV0vVzDlrphn5-AtEB4fLo3ONMplhj9NsEiiUQGUjpVTtULm4ALaoWjSfBgADubig2DghHY+FglAANjTCLA3LAwIROjRycYAOIU2BUmn0xmwegQKxgNy0LAAawlaIqJzONQleIJRNJ5Mp1NpDP5zNZ7NoXN5WsFuqZCClmHIqE6VmaT1aLzt3VAvT+qxmumCPuGEP8AzBCC8mTcThCvwKGWBk32qMOCqq5zouPxNEJJLJfIFOuFLLZHON2e1Qr1ovFkpoMrlCeOSeVqbVmc1-JL5v1BaN2B5xbNwstVettq6DrCLRMZlerrsiA9Ya9PuCfp8AeCQYCq1+6x9GUBPjj8rrmOTKrTGY1vdzevzhs53ZNrb7ZbAuFwmFwbmMdNtyHfOLch4Ykq2Kqum6pZqaV5Mjehb3pepYWlaNoug6BjPJOLrvLOrjzi43q+v6gYJIgfgeCMEYuF4ATev4uhhAetZAViKageeAGHEeojCvQ8gCLw4gAMLMJw7CaMwjTiIwjoTh0XRYQg0ReG4BQBi4WTejkoRBmMUK6JRLgeNEMw+C4EQMeUR7ASxZ7gWinHcXwoj8bwIliRJ0ltBhck9IginKS4qnqdE3peEGAZKSZPjBCkmyQmE-j7iigGKsxp5NqSdkYlx15UGA5DSkabbcR5zreW64LDKkhlTOMTg+OMYS7GFThQpMXgBUurh5JE5noilJ6NmBmaZSc2XQbl+WFU+TL0NoY7obJbw+QgHiVZ4PoBj4dUNU1xFLLo-hkXpXgzAZGzjB4exJYx-UNqxtkcVleYTQVnJFWW2jBOOnmLdOvSrVVG21fV9W7Ys-gGSMoQ6WsuwtV4vWJsed02cNj2jXmyBssmUDlimVqyuxFlMQN91o1g9nXljhA4wOWDISOBglV5S3lftBRpAFdGmWpeRhGFAJpMCMJqdMujeIjlmpYNbEjXAY3MtTON4xKBM1sTt0gajGXo-LmPYzUUB00OKFM-NTos39SR6e4QIDHVvjZIE2kQkLkLC2MmyXZLJMo+lRPvk9VMG0a9Avm+H5fj+f4B0jVlpUNOsU0H0FK4bxsM-aTNoRbv3yRkHNIrRcxzFtwT83t8JKUukLTHkQROLG10a-WWv+6gEAQPcJLvYQ-Ax-gEB0pc9ScII3DcJw9y8FwoksBJUisPIJDM3ny1OIZbi5AGl3RZdPijD4QaDMMbi+LRqlOP4KTDAjzd9a31nt533fEr3-e4P+tKYMSRofzi9ABK8UECoKeM9XLz00DoHOMkpzyUqkpcYt9vBZAPn6UEe0T5nxXAdOYV8b53wOC3ZGbdE5uA7l3Hu01-7kM7kaV+Y0VaVmrLHKWpNta0MoW-ahMcKH0JJGNDOw4s76FXnA5at8hgpE0tEYI4sAixD2hkMi7VBiIkurkDwV8faayfmQihr9368LoZyBhjIw6vnfJ+b8hBfyf1Yb7UhbEDFUKgjQvhpiBGMiEabURMCfriLZssQYngD7hG3gMa+TggzjGro1KImwN5RVosiIhD8SEpggGANA2A6R9xunrfkbEDSFlmv40qrMZxLD8EpGiVFUF4SyBXRYsShi7EiB4eKhlMguGGDox+Eosk5LyfwApsAxqyxDpyJhasHG6MGdk1AuT8nEImbZKZRskLCJoKhb6FSrZLF2GETwjdRh+gKGsLSSiN7+DcIkqih08i9IlvfOO0shlLJGWMtZw0NkzMHITZKAy3AfOWaM1ZjJJk03Tls3xc09mW3zudTwyCWoRCompRRLT6pVRcHVXppdKLaNeWwhsoKvkQqKes6Fodw5WKjrYmOQKMkLOGSs9JPyMobJ8YzPxCK15BORatOGdFvDtWyDEkMZFDIaOiGpTR9ESWOJTOaYpnZpliMwuvHCq1gRRSonRRu0UYl+DaZdeEQIITlxmP0llbhVXUuVmKfGAL1bpPjvayFjqYWDkzjs7O-LAlVNQWkCGBRIjwkhJdGJNy7nRV8BsXItdCHxmIR6h1vyaXTOdarV1czgUZq5VmzZvrtmjkDVqtmBRT4-AOoMXIAUAihSUTizweL2l4WBFEVJqb3XS0LQBP5dLI42Lsf+Zl6avWZtprC3lmqypVOrVvBE9bXBBCCJK8W61LqrhtlRYoKIaCYCyfAVoE7UoLSDR8OYwQRhjAmFMGY5d5h7X6FRONlEgRBFvlfK6aS3nsPSpeytVSIi3JUqXSEwUrmLAcKtNwUVP2NV8OGWifSlXzJluBFsOYEKntgSB3o0Vb14t+IEbw6wn1Bg3qfcMciNjTClS1P9vaAN+zITh3uHZbxFkgnh4DC6iPwmUvDcj4RRhRHXN6M+zyfSdLxRDdD-7SVOOw-BdsLJKA-yNPIOAyz8MBMI4gREdyKNjDyFtOYGDFghCOrJvCdUpjhFtR6smF4+Mae-r-TkvAcTGEIIsAjgnjM+lM+J4JlmArrkOmGLc8I6pRUaolZTyqE5sU49NZkw6BOVN6CZw64WLNrCi3tGp5E5F4qiFtSiLnpZuYDpTJkOWDnPv8oFKDmlm2LFMkMbwm0ooaTkSm89gGyFy3Gc9SgeVXpQC481+SB8yLXz+DsK+8UMhHz2tfU+eEgRbmWI3MyGHgX1fGwrQdxb5sSJDAhy63hopRWimpbS0nGqrgCvVa+gxaujdlrrCb15su5yvUkRuSlaL6pCEgtYL2hg1wO6tKIwIfvsb+8nDG14vNGl8-5wLhngtLDB3czIoQocHxh5XTevT6rxT+IdKrKPVPk0Dhj6CWPOS6dgPpq7QSicQ9J+XcnzTjOQjSDkPCUY-jbkZ3otHLPCls6095qAvBLG4B51U2+UJsiXRCI5p7m3waUS3vpUYEPNimRl2l8CLjuFuL-BrojoQt5rdvhJjesMYm3L0mo3XD3fiZCt1hzMtujH2MHsPR3vk8Uu4DG7mYHvGoxtSKMQYUxemSLT0H+roeeH2PZ1Af+UeVprV3FEJEeKVwbswSuLeODL5RNvtnjhuf7f2I8VAMx-Ji8F1PiZP3gQZjV5aXI5S8SchzG7TV47dqc8v1cQhGhBfVcRx774dwWRHYZAeXpE1cPx8gnqmpP0QfyXsqRpynvLVb3iy-TRNS1OYlLlvVFcMlENj4qyKfxZYLvlTtJCUkaFfjdrfomuniZMCCapDFMCkJcpIglEpqxippkj-hShyv-pKEPGAMXj6L4HekPufOsFRF1kkFtBFLWpFNMHIkCN-myuCugVStOobGvrRKZh4IdFkBGlECQdUpECMAZKtDinIojrQZ8ufo1mxEDkFrlr5KEEMGco2iuEQVRJukpDKlovFnMGMIgSNg2IWj3sCGPhDNvH8KEOLC+iPpMAhg9isM-npDoWMpOowQAeqlADgXkEYQ5g3GYZEFAWRDAa4HRDMHdkHgOhHtgcDkZksOMPITkHVIZKcsZCauGAhj8MsHEetodKERgWnEAZEQTiZIDAEEiEEUuJAS2nwcEZEHVBpKpNkc4W4FIfjjIdEV8H6EmgkQoYbkkCGGoXKopGKj8OhsUEAA */
      id: 'favouritesMachine',
      initial: 'idle',
      context: {
        newWishlistName: '',
        newWishlistPrivacy: 'private',
      },
      states: {
        idle: {
          on: {
            CREATE_NEW_WISHLIST: 'addingNewList',
            CHANGE_NEW_WISHLIST_PRIVACY: {
              actions: assign({
                newWishlistPrivacy: (_, event) => event.value,
              }),
            },
            CHANGE_NEW_WISHLIST_NAME: {
              actions: assign({
                newWishlistName: (_, event) => event.value,
              }),
            },
          },
        },
        addingNewList: {
          invoke: {
            src: 'createNewWishlist',
            onDone: {
              target: 'saved',
              actions: assign({
                newWishlistName: () => '',
                wishlists: (context, event) => {
                  const { newWishlist } = event.data
                  return {
                    ...context.wishlists,
                    [newWishlist.id]: newWishlist,
                  }
                },
              }),
            },
            onError: {
              target: 'showingError',
              actions: assign({
                errors: (_, event) => {
                  if (event.data) {
                    return Object.fromEntries(
                      Object.entries(event.data).map(([key, messages]) => [
                        key,
                        (messages as string[])[0],
                      ]),
                    )
                  }
                  return {}
                },
              }),
            },
          },
        },
        saved: {
          entry: (_, event) => {
            const { callback } = event.data
            if (callback && typeof callback === 'function') {
              callback()
            }
          },
          after: {
            1: {
              target: ['idle'],
            },
          },
        },
        showingError: {
          on: {
            CREATE_NEW_WISHLIST: {
              target: 'addingNewList',
              actions: assign({
                errors: (_) => ({}),
              }),
            },
            CHANGE_NEW_WISHLIST_NAME: {
              target: 'idle',
              actions: assign({
                newWishlistName: (_, event) => event.value,
                errors: (_) => ({}),
              }),
            },
          },
        },
      },
    },
    {
      services: {
        createNewWishlist: async (
          { newWishlistName, newWishlistPrivacy }: FavouritesMachineContext,
          event,
        ) => {
          const newWishlist = await favStore.addNewWishlist(
            newWishlistName,
            newWishlistPrivacy,
          )
          return { newWishlist, callback: event.callback }
        },
      },
    },
  )
}

export type FavouritesMachineInterpreter = Interpreter<
  FavouritesMachineContext,
  any,
  FavouritesMachineEvents
>
